import {useEffect, useState} from 'react';
import {useJobAlert} from "@spa/features/search_job/pc/contexts/JobAlertContext";
import {usePage} from "@inertiajs/react";
import {trackJobAlertRegister} from "@spa/features/search_job/pc/api/analytics/trackEvent"

const JobAlertForm = ({ isInJobPanelList, translations }) => {
    const { route } = usePage().props;
    const [email, setEmail] = useState('');
    const [displayType, setDisplayType] = useState({
        status: '', // success, failure, error
        message: '',
    });
    const { searchCondition, jobAlertResult, updateJobAlertResult, isFromPaidJob, isDoubleOptIn } = useJobAlert();
    const jobAlertTranslations = translations.job_alert;

    // ジョブアラート登録
    const handleSubmit = async (email) => {
        await fetch(route.api.jobAlerts, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                search_conditions: searchCondition,
            }),
        }).then( async (response) => {
            const result = await response.json()

            // ジョブアラート登録を計測
            let registerStatus;
            switch (result.result) {
                case 'success':
                    registerStatus = isDoubleOptIn ? 'confirm' : 'success';
                    break;
                default:
                    registerStatus = 'error';
                    break;
            }
            trackJobAlertRegister(registerStatus, isFromPaidJob, isInJobPanelList ? 'jobPanel' : 'Bottom');

            switch (result.result) {
                case 'failure':
                    setDisplayType({
                        status: 'failure',
                        message: result.message,
                    });
                    break;
                case 'success':
                    updateJobAlertResult({
                        result: result.result,
                    });
                    break;
                case 'error':
                    updateJobAlertResult({
                        result: result.result,
                        message: result.message ?? '',
                    });
                    break;
            }
        });
    }

    useEffect(() => {
        // 入力中のメールアドレスが変更されたら、フォームを初期化
        updateJobAlertResult({
            result: '',
            message: '',
        });
    }, [email]);
    useEffect(() => {
        // ジョブアラート登録結果に応じて表示を変更
        setDisplayType({
            status: jobAlertResult.result,
            message: jobAlertResult.message,
        });
    }, [jobAlertResult]);


    // 表示ロジックを整理
    // ジョブアラート登録成功 or 登録上限達した時
    if (jobAlertResult.result === 'success' || displayType.status === 'error') {

        // ダブルオプトインかつ登録成功時には専用のUIを表示
        if (isDoubleOptIn && jobAlertResult.result === 'success') {
            return (
                <div className="p-mail_confirmation">
                    <div className="p-mail_confirmation_steps">
                        <div className="p-mail_confirmation_step p-mail_confirmation_step--completed">
                            <div className="p-mail_confirmation_step_number">１</div>
                            <span className="p-mail_confirmation_step_text">{jobAlertTranslations.double_optin.confirmation.step1_text}</span>
                        </div>
                        <div className="p-mail_confirmation_step p-mail_confirmation_step--current">
                            <div className="p-mail_confirmation_step_number">２</div>
                            <span className="p-mail_confirmation_step_text">{jobAlertTranslations.double_optin.confirmation.step2_text}</span>
                        </div>
                    </div>
                    <div className="p-mail_confirmation_content">
                        <h3 className="p-mail_confirmation_title">{jobAlertTranslations.double_optin.confirmation.title}</h3>
                        <p className="p-mail_confirmation_text">{jobAlertTranslations.double_optin.confirmation.description}</p>
                    </div>
                </div>
            );
        }

        let formWrapClass = 'c-flash c-flash--success';
        let flashTitle = jobAlertTranslations.single_optin.success_title;
        let flashText = jobAlertTranslations.single_optin.success_text;
        if (displayType.status === 'error') {
            formWrapClass = 'c-flash c-flash--failed';
            flashTitle = jobAlertTranslations.system_error_title;
            flashText = displayType.message; // ここはサーバー側で返却されるエラーメッセージが入る
        }

        return (
            <div className={formWrapClass}>
                <p className="c-flash_ttl">{flashTitle}</p>
                <p className="c-flash_txt">{flashText}</p>
            </div>
        );
    }

    // 初期表示 or ジョブアラート登録失敗
    let failureMessageDiv;
    let formWrapClass = 's-form_wrap';
    if (displayType.status === 'failure') {
        formWrapClass = 's-form_wrap is-error';
        failureMessageDiv = <div className="c-form_validate">{displayType.message}</div>;
    }

    return (
        <div className={formWrapClass}>
            <input
                type="email"
                className="p-mail_input c-form_input s-form_input"
                placeholder={jobAlertTranslations.email_placeholder}
                aria-label={jobAlertTranslations.email_placeholder}
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            {failureMessageDiv}
            <button
                type="submit"
                className="p-mail_btn c-btn c-btn--primary u-mt15"
                onClick={() => handleSubmit(email)}
            >
                {jobAlertTranslations.subscribe_button}
            </button>
        </div>
    )
};

export default JobAlertForm;
